import {
  SpaceBetween,
  Box,
  TextContent,
  ColumnLayout,
  FormField,
  Select,
  Grid,
} from "@cloudscape-design/components-themed";
import { isEqual } from "lodash";
import { Link } from "react-router-dom";
import {
  ConfirmationMerchantInfoItem,
  ConfirmResult,
} from "../../../features/api-interfaces";
import {
  CONFIRMATION_RESULT,
  LABELS,
  CONFIRMATION_AVAILABILITY,
} from "../constants";
import {
  getApiConfirmationResult,
  getConfirmationResultDict,
  getDetailDisplayDict,
  getDetailDisplay,
} from "../util";
interface IChangeApplicationConfirmation {
  merchant: ConfirmationMerchantInfoItem;
  updateItem: (merchant: ConfirmationMerchantInfoItem) => void;
  isMerchantRegistered: boolean;
  confirmResultList: ConfirmResult[];
}
/**
 * 変更申請確認
 */
const ChangeApplicationConfirmation = (
  props: IChangeApplicationConfirmation
) => {
  const { merchant, updateItem, isMerchantRegistered, confirmResultList } =
    props;
  const applicationNos = merchant?.applicationNoList?.map(String) ?? [];
  const isRegistered = confirmResultList.find((item) =>
    isEqual(item.individualHandlingReason, merchant.individualHandlingReason)
  )?.confirmationResult;
  return (
    <SpaceBetween direction={"vertical"} size={"s"}>
      <SpaceBetween direction={"horizontal"} size={"s"}>
        <Box>
          <Box margin={"s"} float={"left"}>
            <TextContent>
              <h5>{LABELS.CONFIRMATION_RESULT}</h5>
            </TextContent>
          </Box>
          <ColumnLayout columns={1}>
            <FormField constraintText={LABELS.BLANK_LITTLE_LONG}>
              <Select
                selectedOption={getConfirmationResultDict(
                  merchant.confirmationResult
                )}
                options={CONFIRMATION_RESULT}
                filteringType={"none"}
                onChange={({ detail: { selectedOption } }) => {
                  updateItem({
                    ...merchant,
                    confirmationResult: getApiConfirmationResult(
                      selectedOption.value!
                    ),
                  });
                }}
                disabled={isMerchantRegistered || isRegistered}
              />
            </FormField>
          </ColumnLayout>
        </Box>
      </SpaceBetween>
      <SpaceBetween direction={"horizontal"} size={"s"}>
        <Box>
          <Box margin={"s"} float={"left"}>
            <TextContent>
              <h5>{LABELS.ITEM_SCREEN_DISPLAY_PRESENCE_ABSENCE}</h5>
            </TextContent>
          </Box>
          <ColumnLayout columns={1}>
            <FormField constraintText={LABELS.BLANK_LITTLE_LONG}>
              <Select
                selectedOption={getDetailDisplayDict(
                  merchant.isDetailReflectFlag
                )}
                options={CONFIRMATION_AVAILABILITY}
                filteringType={"none"}
                onChange={({ detail: { selectedOption } }) => {
                  updateItem({
                    ...merchant,
                    isDetailReflectFlag: getDetailDisplay(
                      selectedOption.value!
                    ),
                  });
                }}
                disabled={isMerchantRegistered || !merchant.isDetailReflectControlFlag}
              />
            </FormField>
          </ColumnLayout>
        </Box>
      </SpaceBetween>
      <Grid gridDefinition={[{ colspan: 2 }, { colspan: 10 }]}>
        <Box margin={"s"} float={"left"}>
          <TextContent>
            <h5>{LABELS.RELATED_APPLICATION_INFORMATION_APPLICATION_NO}</h5>
          </TextContent>
        </Box>
        <Box margin={"s"} float={"left"}>
          <SpaceBetween direction={"horizontal"} size={"s"}>
            {applicationNos.map((applicationNo, index) => (
              <>
                <Link
                  key={applicationNo}
                  to={{
                    pathname: `/application-status/${applicationNo}`,
                  }}
                >
                  {applicationNo}
                </Link>
                {index < applicationNos.length - 1 && "、"}
              </>
            ))}
          </SpaceBetween>
        </Box>
      </Grid>
    </SpaceBetween>
  );
};
export default ChangeApplicationConfirmation;
